import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from '../common';

const routes = [
    {
        matchRegex: '/Customer',
        name: 'Customer listing',
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
        ],
        image: PreviewDListlImg,
    },
]

export default routes;